export default __webpack_public_path__ + "0c1d6dce4652161776206cc30022bb04.png";